import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createActivity, uploadAttachments } from '../api/activityApi'
import type { ActivityCreate } from '../types'

interface CreateArgs {
  dto: ActivityCreate
  files: File[]
}

/**
 * Yeni etkinlik oluşturur: önce ana + alt kayıtlar (POST /activities), sonra varsa dosya ekleri
 * (POST /{id}/attachments). Başarıda liste sorgusu invalidate edilir → listeye dönünce yeni kayıt görünür.
 * Dosya adımı kısmen başarısızsa etkinlik yine oluşmuştur; hata çağırana iletilir (pending-first tradeoff).
 */
export function useCreateActivity() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ dto, files }: CreateArgs): Promise<number> => {
      const { id } = await createActivity(dto)
      if (files.length > 0) {
        await uploadAttachments(id, files)
      }
      return id
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['activities'] })
    },
  })
}
